import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Grid2 as Grid,
  Tooltip,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import PersonIcon from '@mui/icons-material/Person'
import PeopleIcon from '@mui/icons-material/People'
import VideocamIcon from '@mui/icons-material/Videocam'
import Colors from '../../utils/colors.json'

const styles = (theme: any) => ({
  appointmentCard: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    padding: 2,
  },
  iconBox: {
    padding: 5,
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    fontSize: 30,
  },
  stackAavatar: {
    width: 50,
    height: 50,
    marginRight: '-10px',
    border: '2px solid white',
  },
  fixedAavatar: {
    width: 50,
    height: 50,
    backgroundColor: 'grey.300',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '0.9rem',
  },
  appointmentsText: {
    textWrap: 'nowrap',
  },
})

// Sample avatar images for illustration purposes
const avatars = [
  'https://i.pravatar.cc/150?img=1',
  'https://i.pravatar.cc/150?img=2',
  'https://i.pravatar.cc/150?img=3',
  'https://i.pravatar.cc/150?img=2',
  'https://i.pravatar.cc/150?img=1',
]

const AppointmentsCard: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.appointmentCard} elevation={0}>
      <CardContent>
        <Typography
          variant='h6'
          fontWeight='bold'
          gutterBottom
          color={Colors.TEXT_COLOR_MAIN}
        >
          Appointments
        </Typography>

        {/* Avatar Group */}
        <Box display='flex' alignItems='center' mb={2}>
          {avatars?.slice(0, 4).map((src, index) => (
            <Tooltip title={`Person ${index + 1}`} key={index}>
              <Avatar
                src={src}
                alt={`Avatar ${index + 1}`}
                className={classes?.stackAavatar}
              />
            </Tooltip>
          ))}
          <Avatar className={classes?.fixedAavatar}>+3</Avatar>
        </Box>

        {/* Statistics Section */}
        <Grid container spacing={2}>
          {/* Total Leads */}
          <Grid size={{ xs: 4 }}>
            <Box
              p={1}
              border='1px solid #e0e0e0'
              borderRadius={2}
              display={'flex'}
              justifyContent={'space-between'}
              flexDirection={'column'}
              gap={1}
            >
              <Box>
                <PersonIcon className={classes?.iconBox} />
              </Box>
              <Box>
                <Typography variant='h5' fontWeight='bold'>
                  8
                </Typography>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  className={classes?.appointmentsText}
                >
                  Total Leads
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Home Visits */}
          <Grid size={{ xs: 4 }}>
            <Box
              p={1}
              border='1px solid #e0e0e0'
              borderRadius={2}
              display={'flex'}
              justifyContent={'space-between'}
              flexDirection={'column'}
              gap={1}
            >
              <Box>
                <PeopleIcon className={classes?.iconBox} />
              </Box>
              <Box>
                <Typography variant='h5' fontWeight='bold'>
                  6
                </Typography>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  className={classes?.appointmentsText}
                >
                  Home Visits
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Video Consultations */}
          <Grid size={{ xs: 4 }}>
            <Box
              p={1}
              border='1px solid #e0e0e0'
              borderRadius={2}
              display={'flex'}
              justifyContent={'space-between'}
              flexDirection={'column'}
              gap={1}
            >
              <Box>
                <VideocamIcon className={classes?.iconBox} />
              </Box>
              <Box>
                <Typography variant='h5' fontWeight='bold'>
                  10
                </Typography>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  className={classes?.appointmentsText}
                >
                  Video Consultations
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default AppointmentsCard
